/* Maison Thaevia — Collections Index
   Handles active state, hover pause, and 3.6s auto-drift.
   Matches the CollectionsIndex component behaviour in Homepage.jsx. */

if (!customElements.get('mt-collections-index')) {
  class MTCollectionsIndex extends HTMLElement {
    connectedCallback() {
      this._rows      = Array.from(this.querySelectorAll('.mt-cindex__row'));
      this._panes     = Array.from(this.querySelectorAll('.mt-cindex__pane'));
      this._discovers = Array.from(this.querySelectorAll('.mt-cindex__discover'));
      this._active    = 0;
      this._hovering  = false;

      /* Hover on individual rows sets the active index */
      this._rows.forEach((row, i) => {
        row.addEventListener('mouseenter', () => {
          this._hovering = true;
          this._setActive(i);
        });
      });

      /* Entering/leaving the grid pauses/resumes the drift */
      const grid = this.querySelector('.mt-cindex__grid');
      if (grid) {
        grid.addEventListener('mouseenter', () => { this._hovering = true; });
        grid.addEventListener('mouseleave', () => { this._hovering = false; });
      }

      /* Auto-drift every 3.6 s when idle — matches prototype interval */
      this._drift = setInterval(() => {
        if (!this._hovering) {
          this._setActive((this._active + 1) % this._rows.length);
        }
      }, 3600);

      this._setActive(0);
    }

    _setActive(i) {
      this._active = i;

      this._rows.forEach((row, idx) =>
        row.classList.toggle('mt-cindex__row--active', idx === i)
      );
      this._panes.forEach((pane, idx) =>
        pane.classList.toggle('mt-cindex__pane--active', idx === i)
      );
      this._discovers.forEach((el, idx) =>
        el.classList.toggle('mt-cindex__discover--active', idx === i)
      );
    }

    disconnectedCallback() {
      clearInterval(this._drift);
    }
  }

  customElements.define('mt-collections-index', MTCollectionsIndex);
}
